import { render } from "./simpeg-pegawai-detail.vue?vue&type=template&id=3f3cc339&scoped=true"
import script from "./simpeg-pegawai-detail.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-detail.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-detail.vue?vue&type=style&index=0&id=3f3cc339&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3cc339"]])

export default __exports__